import { FC, memo } from "react";
import dynamic, { DynamicOptions } from "next/dynamic";
import type { UseProductReturnType } from "@/hooks/product/types";
import { useWindowSize } from "@/hooks/useWindowSize";
import { getBreakpointVal } from "@/styles/utils/Utils";
import { breakpoints } from "@/styles/utils/vars";
import { Button } from "@/ui/Button/Button";
import { EntityImage } from "@/ui/EntityImage/EntityImage";
import { Modal } from "@/ui/Modal/Modal";
import { FeedbackFormType, IMAGE_PRODUCT_CARD_SIZE_MODIFICATOR } from "@/utils/constants";
import { Gallery, StyledMedia } from "./StyledDetail";
import { IMAGE_CONFIG } from "../constants";
import { cssMediaModal, GallerySliderPropsType, PreviewSlider } from "../parts";
import { cssZoomIn } from "../StyledProduct";
export type MediaPropsType = Pick<UseProductReturnType, "images" | "name">;
const Recall = dynamic(() => import("../../Forms/Recall").then(mod => mod.Recall), {
  ssr: false
});
const GallerySlider = dynamic(((() => import("@/components/Products/parts/Media/Gallery").then(mod => mod.Gallery)) as DynamicOptions<GallerySliderPropsType>), {
  ssr: false
});
const PRESENTATION_TXT = "Заказать видео-презентацию";
const Media: FC<MediaPropsType> = memo(({
  name,
  images,
  children
}) => {
  const {
    width
  } = useWindowSize();
  const isLessSm = width !== undefined && width <= getBreakpointVal(breakpoints.sm);
  const imageWidth = isLessSm ? IMAGE_CONFIG.detail.size.width - IMAGE_PRODUCT_CARD_SIZE_MODIFICATOR : IMAGE_CONFIG.detail.size.width + IMAGE_PRODUCT_CARD_SIZE_MODIFICATOR;
  const imageHeight = isLessSm ? IMAGE_CONFIG.detail.size.height - IMAGE_PRODUCT_CARD_SIZE_MODIFICATOR : IMAGE_CONFIG.detail.size.height + IMAGE_PRODUCT_CARD_SIZE_MODIFICATOR;
  return <StyledMedia>
      {children}

      <Gallery>
        {images.length > 0 ? <>
            <PreviewSlider alt={name || ""} images={images} width={imageWidth} height={imageHeight} objectFit={"contain"} />
            <Modal closeMode={"destroy"} variant={"full"} disclosure={<Button icon={"ZoomIn"} variant={"box"} className={cssZoomIn} />} classNameBackdrop={cssMediaModal}>
              <GallerySlider images={images} />
            </Modal>
          </> : <EntityImage imagePath={images[0]} imageAlt={name || ""} width={imageWidth} height={imageHeight} priority withPreloader={true} />}
      </Gallery>

      <Modal closeMode={"destroy"} disclosure={<Button variant={"link"} icon={"Ratio"} size={"small"}>
            {PRESENTATION_TXT}
          </Button>} title={PRESENTATION_TXT}>
        <Recall typeQuery={FeedbackFormType.VIDEO_PRESENTATION} />
      </Modal>
    </StyledMedia>;
});
Media.displayName = "Media";
export { Media };